import { defineStore } from 'pinia';

export const useViewerStore = defineStore('viewer', {
    state: () => ({
        bodyClass: ''
    }),
    actions: {
        async setBodyClass(bodyClass) {
            this.bodyClass = bodyClass;
        },


    },
});
